// extracted by mini-css-extract-plugin
module.exports = {"curtain":"Curtain_curtain__3rAAQ","growBackground":"Curtain_growBackground__3JAOQ","bottom":"Curtain_bottom__2_Xxo"};